/**
 * Notice d'information des patients sur leurs données personnelles
 * (loi n°2013-015 du 21 mai 2013, art. 15). À afficher à l'accueil et à
 * remettre au patient à l'ouverture de son dossier.
 */
import { e } from '../impression'

export function documentNotice(config = {}) {
  const clinique = e(config.nom || 'La clinique')
  const adresse = [config.adresse, config.ville].filter(Boolean).map(e).join(', ')
  const contact = [config.telephone ? 'Tél. ' + e(config.telephone) : '', config.email ? e(config.email) : ''].filter(Boolean).join(' · ')
  const corps = `
    <div class="texte" style="white-space:normal">
      <div class="section">Qui est responsable de vos données ?</div>
      <p>${clinique}${adresse ? ', ' + adresse : ''}${contact ? ' (' + contact + ')' : ''}.</p>

      <div class="section">Pourquoi nous les utilisons</div>
      <p>Pour vous soigner et assurer votre suivi médical (consultations, examens, hospitalisation, ordonnances),
      pour la facturation et, si vous êtes assuré, pour la prise en charge par votre assurance.</p>

      <div class="section">Quelles données</div>
      <p>Votre identité et vos coordonnées, une personne à prévenir, vos informations d'assurance, et les données de santé
      nécessaires à vos soins (motifs de consultation, diagnostics, constantes, résultats d'examens, traitements).
      Sans ces informations, nous ne pouvons pas assurer votre prise en charge dans de bonnes conditions.</p>

      <div class="section">Qui peut les voir</div>
      <p>Seul le personnel de la clinique qui en a besoin pour son travail (médecins, infirmiers, laboratoire, accueil, caisse),
      selon ses fonctions. Chaque ouverture de votre dossier est enregistrée. Votre assurance reçoit uniquement ce qui est
      nécessaire au remboursement. Le prestataire informatique de la clinique n'accède aux données que pour la maintenance,
      sous engagement de confidentialité.</p>

      <div class="section">Où elles sont conservées</div>
      <p>Sur un serveur sécurisé situé hors du Mali, dans l'Union européenne, avec chiffrement des échanges et sauvegardes chiffrées,
      dans le cadre prévu par l'Autorité de Protection des Données à caractère Personnel (APDP).
      Elles sont conservées pendant la durée nécessaire à votre suivi médical et aux obligations légales de la clinique.</p>

      <div class="section">Vos droits</div>
      <p>Vous pouvez à tout moment, gratuitement, demander une copie de vos données (droit d'accès), leur correction ou leur
      mise à jour, ou vous opposer à un traitement pour un motif légitime (loi n°2013-015, articles 12, 13 et 19).
      Adressez-vous à l'accueil : une réponse vous sera donnée dans un délai de 30 jours.
      Vous pouvez aussi saisir l'APDP (Autorité de Protection des Données à caractère Personnel), Bamako.</p>
    </div>`
  return {
    titre: 'Vos données personnelles',
    sousTitre: "Notice d'information des patients",
    corps,
    note: 'Loi n°2013-015 du 21 mai 2013 portant protection des données à caractère personnel',
  }
}
